import { registerMicroApps, start } from 'qiankun'

/**
 * 微应用路由初始化
 * @param MicroList
 */
function intRouter(router, store, MicroList) {
  let childRoute = []
  MicroList.forEach((item) => {
    // 以微应用名称为路径
    childRoute.push('/' + item.name + '/')
  })
  const isChildRoute = path => childRoute.some(item => path.startsWith(item))
  const rawAppendChild = HTMLHeadElement.prototype.appendChild
  const rawAddEventListener = window.addEventListener
  router.beforeEach((to, from, next) => {
    // 从子项目跳转到主项目
    if (isChildRoute(from.path) && !isChildRoute(to.path)) {
      HTMLHeadElement.prototype.appendChild = rawAppendChild
      window.addEventListener = rawAddEventListener
    }
    next()
  })
}

/**
 * 微应用初始化
 * @param router
 * @param store
 */
function initMicro(router, store) {
  // 定义微应用
  // 需要区分生产环境和测试环境
  const env = process.env.NODE_ENV
  console.log('env', env)
  const MicroList = [
    {
      name: 'eosWeb',
      description: 'eos web 应用',
      entry: env == 'development' ? '//localhost:6060' : '/eos-web/',
      container: '#microMain',
      activeRule: '/micro-container/eos-web',
    },
    {
      name: 'admin',
      description: '素养管理后台',
      entry: env == 'development' ? '//localhost:9528' : '/admin/',
      container: '#microMain',
      activeRule: '/micro-container/admin',
    },
    {
      name: 'vue',
      description: '定制vue应用',
      entry: env == 'development' ? '//localhost:7010' : '/v/vue/',
      container: '#microMain',
      activeRule: '/micro-container/v/vue',
    },
  ]
  // 初始化
  registerMicroApps(MicroList, {})
  // 路由设置
  intRouter(router, store, MicroList)
  // 启动微服务{ singular: false }
  start()
  console.log('micro start')
}

export {
  initMicro
}
